import ApplicationSerializer from 'teacher-ui-client/serializers/application'

export default class StandardsSetSerializer extends ApplicationSerializer {}
